import "./alertcases.scss";
import { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { BsArrowLeft } from "react-icons/bs";
import { LiaPlusSolid } from "react-icons/lia";
import { useNavigate } from "react-router";

import Tooltip from "../../../shared/components/tooltip/tooltip";
import { roleWrite } from "../../../shared/constants/user-roles";
import AuthContext from "../../../shared/context/auth-context";
import { useHttpGet } from "../../../shared/hooks/use-httpNonTable";
import { getData, succesfulToast } from "../../../shared/utils/api";
import { useBack } from "../../../shared/utils/use-back";
import AssignUserPopup from "../alertcase/assign_user_popup";
import AlertCasesTab from "./tabs/alertcases-tab";

const AlertCasesList = () => {
  const { handleBack } = useBack();
  const authCtx = useContext(AuthContext);
  const [assignUserModalVisible, setAssignUserModalVisible] = useState(false);
  const [selectedAlertCase, setSelectedAlertCase] = useState<string>("");
  const [isUserReadOnly, setIsUserReadOnly] = useState(false);

  const { sendRequest: updateAlertCaseAssignUser, status: updateAlertCaseAssignUserStatus, error: updateAlertCaseAssignUserError } = useHttpGet(getData, false, authCtx.token, "default", "manager");
  const { sendRequest: getAlertCase, status: getAlertCaseStatus, data: getAlertCaseData, error: getAlertCaseError } = useHttpGet(getData, false, authCtx.token, "alertcaseRecord", "manager");
  const [blockInput, setBlockInput] = useState<boolean>(true);

  const navigate = useNavigate();

  useEffect(() => {
    if (updateAlertCaseAssignUserStatus === "completed" && !updateAlertCaseAssignUserError) {
      succesfulToast("Successfully assigned");
      navigate("/manager/alertcases");
      setAssignUserModalVisible(false);
    }
  }, [updateAlertCaseAssignUserStatus, updateAlertCaseAssignUserError]);

  useEffect(() => {
    const rolesArray = authCtx.selectedTenant.roles;
    if (rolesArray.indexOf(roleWrite) !== -1) {
      setBlockInput(false);
    }
  }, [authCtx.selectedTenant, authCtx.systemAdmin]);

  useEffect(() => {
    if (getAlertCaseStatus === "completed" && getAlertCaseData && !getAlertCaseError) {
      navigate(`/manager/alertcases/${getAlertCaseData.id}`);
    }
  }, [getAlertCaseStatus, getAlertCaseData, getAlertCaseError]);

  const handleActionClick = (action_key: string, rowId: string) => {
    const rolesArray = authCtx.selectedTenant.roles;
    const hasWriteRole = rolesArray.indexOf(roleWrite) !== -1;
    if (!hasWriteRole) {
      return;
    }
    setSelectedAlertCase(rowId);
    setAssignUserModalVisible(true);
  };

  const handleAssignUser = (userId: string) => {
    if (selectedAlertCase) {
      updateAlertCaseAssignUser(`assign_user/${selectedAlertCase}/${userId}`);
    }
  };

  const handleBeforeRowClick = async (rowId: string) => {
    await getAlertCase(`alertcase/${rowId}`);
    return false;
  };

  useEffect(() => {
    const roles = authCtx.selectedTenant.roles || [];
    setIsUserReadOnly(roles.length === 1 && roles[0] === "Read");
  }, [authCtx.selectedTenant]);

  return (
    <div className="alertcaseListPage">
      <div onClick={() => handleBack()} className="alertcaseListPage-navButton">
        <BsArrowLeft />
      </div>

      <div className="alertcaseListPage-header">
        <h1>AlertCases</h1>
      </div>
      {!blockInput && (
        <div className="alertcaseListPage-saveButton">
          {!isUserReadOnly && (
            <Tooltip content={"New AlertCase"} direction="top" delay={350}  >
              <Button name="new" className="alertcaseListPage-save" onClick={() => navigate("/manager/alertcases/new")}>
                <LiaPlusSolid />
              </Button>
            </Tooltip>
          )}
        </div>
      )}
      <div className="alertcaseListPage-tabs">
        <AlertCasesTab onActionClick={handleActionClick} onBeforeRowClick={handleBeforeRowClick} />
      </div>
      <AssignUserPopup
        handlePopupClosed={() => setAssignUserModalVisible(false)}
        show={assignUserModalVisible}
        handleAssignUser={handleAssignUser}
      />
    </div>
  );
};

export default AlertCasesList;